import { __awaiter, __generator } from "tslib";
import { Context, ContextCancelation } from '../../core/context';
import { applyDestinationMiddleware, } from '../middleware';
/**
 * Convenience class for writing 3rd party destination plugins
 */
var Destination = /** @class */ (function () {
    function Destination(name, version, actions) {
        this.name = name;
        this.version = version;
        this.actions = actions;
        this.type = 'destination';
        this.middleware = [];
        this.alias = this._createMethod('alias');
        this.group = this._createMethod('group');
        this.identify = this._createMethod('identify');
        this.page = this._createMethod('page');
        this.screen = this._createMethod('screen');
        this.track = this._createMethod('track');
    }
    Destination.prototype.isLoaded = function () {
        return true;
    };
    Destination.prototype.load = function () {
        console.debug("loaded destination plugin: ".concat(this.name, " v").concat(this.version));
        return Promise.resolve();
    };
    Destination.prototype.addMiddleware = function () {
        var _a;
        var fn = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fn[_i] = arguments[_i];
        }
        (_a = this.middleware).push.apply(_a, fn);
    };
    Destination.prototype.transform = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var modifiedEvent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, applyDestinationMiddleware(this.name, ctx.event, this.middleware)];
                    case 1:
                        modifiedEvent = _a.sent();
                        if (modifiedEvent == null) {
                            ctx.cancel(new ContextCancelation({
                                retry: false,
                                reason: 'dropped by destination middleware',
                            }));
                        }
                        return [2 /*return*/, new Context(modifiedEvent)];
                }
            });
        });
    };
    Destination.prototype._createMethod = function (action) {
        var _this = this;
        return function (ctx) { return __awaiter(_this, void 0, void 0, function () {
            var transformedCtx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.actions[action])
                            return [2 /*return*/, ctx];
                        return [4 /*yield*/, this.transform(ctx)];
                    case 1:
                        transformedCtx = _a.sent();
                        return [4 /*yield*/, this.actions[action](transformedCtx)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, ctx];
                }
            });
        }); };
    };
    return Destination;
}());
export { Destination };
//# sourceMappingURL=destination.js.map